import React from 'react'
import styled from 'styled-components'

const StyledSFSymbol = styled.span`
  font-family:
    'SF Pro',
    'SF Symbols',
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
`

interface SFSymbolLabelProps {
  text: string
}

export const SFSymbolLabel = ({ text }: SFSymbolLabelProps) => {
  return (
    <>
      {Array.from(text).map((char, i) => {
        const codePoint = char.codePointAt(0)!
        const isSFSymbol =
          (codePoint >= 0xe000 && codePoint <= 0xf8ff) ||
          (codePoint >= 0xf0000 && codePoint <= 0xffffd) ||
          (codePoint >= 0x100000 && codePoint <= 0x10fffd)

        return isSFSymbol ? (
          <StyledSFSymbol key={i}>{char}</StyledSFSymbol>
        ) : (
          char
        )
      })}
    </>
  )
}
